let language = {
    DETAIL_PRICE_TITLE: "产品价格",
    DETAIL_PRICE_LIST_TITLE: "产品批量价格",
    DETAIL_EXCL: "(不含增值税)",
    DETAIL_PRICE_TITLE_MOBILE: "价格:",
    DETAIL_EXCL_MOBILE: "(不含增值税)",
    DETAIL_PRICE_LIST_TITLE_MOBILE: "分级价目表",
    DETAIL_PRICE_ITEM_TITLE_QTY: "数量",
    DETAIL_PRICE_ITEM_TITLE_US: "美国",
    DETAIL_PRICE_ITEM_TITLE_OTHERS: "其他",
    DETAIL_PRICE_ITEM_TITLE_PRICE:"价格",
    DETAIL_EMPTY_PRICE: "产品批量价格为空。",
    DETAIL_MOQ_TIP: "最小订购量为",
    DETAIL_MOQ_TIP_MOBILE: "最小订购量为",
    DETAIL_VIEW_BULK_PRICE:"查看批量价格"
};

export { language }
